<template>
    <RouterView v-slot="{ Component, route }">
        <component
            :is="Component"
            v-if="route.meta?.fullscreen"
        />
        <AuthenticatedLayout v-else>
            <component :is="Component" />
        </AuthenticatedLayout>
    </RouterView>
    <ToastNotification
        v-if="showLayout"
        class="z-50"
    />
    <Toaster position="bottom-left" />
    <ChooseTenant />
</template>
<script setup>
import { Toaster } from 'vue-sonner';
import { initObi } from 'obi-loader';
const appStore = useAppStore();
const userStore = useUserStore();

const route = useRoute();

const showLayout = computed(() => {
    return (
        userStore.isAuthenticated &&
        route.name !== 'Login' &&
        route.name !== 'Register' &&
        route.name !== 'Update your preferences'
    );
});

onMounted(async () => {
    appStore.setDeviceType();
    await appStore.initGoogle();

    if (import.meta.env.VITE_ENV == 'development') {
        initObi({
            apiKey: import.meta.env.VITE_OBI_KEY,
            position: 'bottom-right',
        });
    }
});
</script>
<style>
/* width */
::-webkit-scrollbar {
    width: 5px;
    height: 5px;
    padding: 5px;
    border-radius: 10px;
}

/* Track */
::-webkit-scrollbar-track {
    border-radius: 10px;
    padding: 5px;
}

/* Handle */
::-webkit-scrollbar-thumb {
    background: #c4c4c4;
    padding: 5px;
    border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
    background: #868686;
}
</style>
